/********************************************************************************
 * Copyright (c) 2026 Renesas.
 *
 * All rights reserved. This program and the accompanying materials
 * is the property of Renesas and must not be
 * reproduced, disclosed to any third party, or used in any
 * unauthorized manner without written consent.
 ********************************************************************************/
export interface BuildInfo {
  commitHash: string;
  buildTime: string;
}

export async function logBuildInfo(): Promise<void> {
  try {
    const response = await fetch('./build-info.json', { cache: 'no-store' });
    if (!response.ok) {
      console.warn(`[Landing page build] Build info is unavailable. HTTP ${response.status}.`);
      return;
    }

    const buildInfo = parseBuildInfo(await response.json());
    if (!buildInfo) {
      console.warn('[Landing page build] Build info is unavailable.');
      return;
    }

    console.info(`[Landing page build] commit=${buildInfo.commitHash} buildTime=${buildInfo.buildTime}`);
  } catch (error) {
    console.warn('[Landing page build] Failed to retrieve build info.', error);
  }
}

function parseBuildInfo(value: unknown): BuildInfo | undefined {
  if (!isRecord(value)) {
    return undefined;
  }
  const { commitHash, buildTime } = value;
  if (typeof commitHash !== 'string' || !commitHash || typeof buildTime !== 'string' || !buildTime) {
    return undefined;
  }
  return {
    commitHash,
    buildTime
  };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}
